export default "__VITE_ASSET__BfSkDX99__"